import { html } from "lit-html"
import ImageModal from "../embeds/image"
import { keyClickWrapper } from "../utils"
import { DOC_ICON_MAP, MAX_DOCS } from "../constants"

const ImageDoc = (doc, category) => html`
  <span
    class="link-text-color cursor-pointer"
    role="button"
    tabindex="0"
    @click=${(e) => ImageModal(e.target)}
    @keydown=${(e) => keyClickWrapper(e, (ev) => ImageModal(ev.target))}
    data-image-src=${`${doc.upload_domain}/${doc.link}`}
    data-image-title=${doc.name || "Document"}
  >
    <i
      class=${category in DOC_ICON_MAP ? DOC_ICON_MAP[category] : "fas fa-file"}
    ></i>
    &nbsp; ${doc.name || "Document"}
  </span>
`

const DocumentLinkList = (documents) =>
  documents.slice(0, MAX_DOCS - 1).map(
    (doc) => html`
      <p class="mb-5">
        ${doc.category === "Image"
          ? ImageDoc(doc, doc.category)
          : html`
              <a href=${doc.link_url}>
                <i
                  class=${doc.category in DOC_ICON_MAP
                    ? DOC_ICON_MAP[doc.category]
                    : "fas fa-file"}
                ></i>
                &nbsp; ${doc.name || "Document"}
              </a>
            `}
      </p>
    `
  )

export default DocumentLinkList
